import type { SpineSection } from "../hooks/useVariantCRun";
import type { RunModuleScope } from "../state";

/**
 * The spine rows that belong to the current run.
 *
 * Spine row ids ARE module ids (see ``spineSectionsFromConfig``), so a scoped
 * run keeps the rows it was started for plus any row the run has actually
 * touched (status other than ``queued``) — that covers modules the backend
 * adds on its own (e.g. the title page) and sections drafted earlier. The
 * whole template is returned unchanged (same array) when the run has no known
 * scope (whole document, restored / loaded run) or the scope belongs to a
 * different run. Pure.
 */
export function filterSectionsToRunScope<T extends SpineSection>(
  sections: T[],
  scope: RunModuleScope | null | undefined,
  runId: string | null,
): T[] {
  if (!scope || scope.runId !== runId || scope.moduleIds.length === 0) return sections;
  const ids = new Set(scope.moduleIds);
  const scoped = sections.filter((s) => ids.has(s.id) || s.status !== "queued");
  return scoped.length === sections.length ? sections : scoped;
}
